import { ApiClient, apiClient } from "../../../../core/api_client";
import {
  IProject,
  projectFromJson,
  IProjectApartment,
  IPaginated,
  IProjectApartmentFilter,
  paginatedDataFromJson,
  projectApartmentFromJson,
  projectApartmentFilterToJson,
} from "./entities";
import { Failure } from "../../../../core/failure";

// The API's room counts stop at fourRoom. Until it also sends fiveRoom, the
// 5-room apartments are fetched from the search endpoint and counted here.
// Search only returns apartments that are still on sale.
export const getFiveRoomApartments = async (projectPlanId: number | string): Promise<any[]> => {
  try {
    const res = await apiClient.post(`/searchApartmentsV2`, {
      projectPlanId: Number(projectPlanId),
      page: 1,
      limit: 1000,
      data: {
        sectorTypes: [],
        floor: { from: "0", to: "100" },
        roomCounts: [{ roomCount: "5" }],
        repairTypes: [],
      },
    });
    return res.data?.data ?? [];
  } catch {
    return [];
  }
};

interface IProjectRepo {
  getProjectDetail: (id: string) => Promise<IProject>;
  getProjectApartments: (filter: IProjectApartmentFilter) => Promise<IPaginated<IProjectApartment>>;
}

const ProjectRepoImplFactory = (apiClient: ApiClient): IProjectRepo => {
  const r: IProjectRepo = {
    getProjectDetail: async (id) => {
      try {
        const res = await apiClient.get(`/getProjectSectors/${id}`);
        const project = projectFromJson(res.data);
        if (project.sectors.length > 0 && res.data.sectors[0].fiveRoom === undefined) {
          const fiveRoomApartments = await getFiveRoomApartments(id);
          project.sectors.forEach((sector) => {
            sector.fiveRoomCount = fiveRoomApartments.filter(
              (a) => `${a.project_plan_sector_plan_id}` === sector.id
            ).length;
          });
        }
        return project;
      } catch (error: any) {
        const failure: Failure = {
          message: error.message ?? "Unhandled failure",
        };
        throw failure;
      }
    },
    getProjectApartments: async (filter) => {
      try {
        const data = projectApartmentFilterToJson(filter);
        const res = await apiClient.post(`/searchApartmentsV2`, data);
        return paginatedDataFromJson(res.data, projectApartmentFromJson);
      } catch (error: any) {
        const failure: Failure = {
          message: error.message ?? "Unhandled failure",
        };
        throw failure;
      }
    },
  };

  return r;
};

export const ProjectRepoImpl = ProjectRepoImplFactory(apiClient);
